import { useSelector } from 'react-redux';
import { getGameId } from '../ducks';

export const useGetGameId = () => {
  const gameId = useSelector(getGameId);
  return gameId;
};
